type PricingToolbarProps = {
  title: string;
  description: string;
  children?: React.ReactNode;
};

export function PricingToolbar({
  title,
  description,
  children,
}: PricingToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div className="flex flex-col">
          <h2 className="flex items-center font-bold text-2xl tracking-tight">
            {title}
          </h2>
          <p className="text-muted-foreground">{description}</p>
        </div>
        {children ? (
          <div className="flex items-center space-x-2">{children}</div>
        ) : null}
      </div>
    </div>
  );
}
